<template>
  <div id="eev-calendar" class="fwf_zone_loading" :class="{'for-smartphone':mobile}">
    <transition name="fade">
      <loading v-show="loadingState"></loading>
    </transition>
    <desktop-calendar
      v-if="!mobile && lang"
      :eventsCategories="eventsCategories"
      :lang="lang"
    ></desktop-calendar>
    <smartphone-calendar
      v-else-if="mobile && lang"
      :eventsCategories="eventsCategories"
      :lang="lang"
    ></smartphone-calendar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import store from '@/store/store.js'
import Api from '@/api/axios-api.js'
import desktopCalendar from '@/components/desktopCalendar.vue'
import smartphoneCalendar from '@/components/smartphoneCalendar.vue'
import loading from '@/components/loading.vue'
import { isMobile } from 'mobile-device-detect'
export default {
  components: {
    desktopCalendar,
    smartphoneCalendar,
    loading
  },

  data: () => ({
    eventsCategories: {},
    lang: null,
    mobile: isMobile ? 'mobile' : null
  }),

  methods: {
    ...mapActions([
      'setLoadingOn',
      'setLoadingOff'
    ]),
    fetchData () {
      let restURL = window.wpApiSettings.rootFairweb
      let obj = this
      Api.get(restURL + 'event-categories/' + this.lang).then(function (response) {
        let data = response.data
        if (data.liste) {
          obj.eventsCategories = data.liste
        }
      })
    }
  },

  created () {
    this.setLoadingOn()
  },

  mounted () {
    // Définit la langue
    this.lang = window.wpApiSettings.lang
    this.fetchData()
  },

  computed: {
    ...mapGetters([
      'loadingState'
    ]),

    canUpdate: function () {
      if (!this.appOptions || !this.appOptions.can_update) {
        return false
      }
      return true
    }
  },

  store
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#eev-calendar{
  background: #e8eef6;
  padding:1rem;
  border-radius: 17px;
  user-select: none;
}

@media (min-width: 1904px){
  .container {
      max-width: 1185px;
  }
}

.row {
  margin-right: -15px;
  margin-left: -15px;
  margin-top: 0;
  margin-bottom: 0;
}

.col, .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col-auto, .col-lg, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-auto, .col-md, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md-auto, .col-sm, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-auto{
  padding-top: 0;
  padding-bottom: 0;
}

.col-2{
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.666667%;
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}

.container {
    padding: 0 15px;
}

body.has-calendar #full-background{
  background:#FFF;
}

body.archive.has-calendar h1.entry-title{
  color:#4A4A4A;
  text-shadow: none;
  padding-left: 2rem;
}

body.archive .breadcrumbs, body.archive .breadcrumbs a, body.blog .breadcrumbs, body.blog .breadcrumbs a{
  color:#4A4A4A;
  padding-left: 1rem;
}

.sidebar{
  box-shadow:4px 0px 4px rgba(0,0,0,0.1);
  z-index: 7;
}

#elnna_col_content{
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue